import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Helpers, Report, ReportFile, ReportFileType} from '../../../../model';
import {ReportProvider} from '../../../../providers';
import {ReportService} from '../../../../services/report.service';
import { saveAs } from 'file-saver/dist/FileSaver';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CreateFolderModal } from './modals/create-folder/create-folder.modal';
import { Subject } from 'rxjs';
import { UploadFileModal } from './modals/upload-file/upload-file.modal';
import { ContextMenuComponent } from 'ngx-contextmenu';
import { FileActionType } from 'src/app/model/enums/file.action.type';
import { DocumentType } from 'src/app/model/enums/document.type';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { ConfirmationDialogComponent } from 'src/app/components/fields';
import { HttpEventType } from '@angular/common/http';
import { PreviewFileComponent } from './modals/preview/preview-file.component';
import { CrmAlertComponent } from 'src/app/modules/orderformlib/components/crm-alert/crm-alert.component';
import {LogService } from 'src/app/services';


@Component({
  selector: 'app-report-files',
  templateUrl: './report-files.component.html',
  styleUrls: ['./report-files.component.scss']
})
export class ReportFilesComponent implements OnInit, OnDestroy {
  @ViewChild(ContextMenuComponent) basicMenu: ContextMenuComponent;
  @ViewChild('directoryContextMenu') directoryContextMenu: ContextMenuComponent;
  @ViewChild('attachement') attachFileRef: ElementRef;
  @ViewChild('alert') alert: CrmAlertComponent;

  currentReport: Report = new Report();
  private reportSub: any;
  isLoading = false;

  reportFiles: ReportFile[] = [];
  allFiles: ReportFile[] = [];

  ReportFileType = ReportFileType;
  childNav: ReportFile[] = [];

  rootFolder: ReportFile;
  checkedSelected: ReportFile;
  folderSelected: ReportFile = null;

  modalRef: BsModalRef;

  FileAction = FileAction;
  fileAction: FileAction = FileAction.ROOT_SELECTED;
  isCheck: boolean = false;
  ExtenstiionType = ExtenstiionType;

  files: ReportFile[] = [];
  uploadProgress: number = 0;
  isUpload: boolean = false;

  constructor(
    private reportService: ReportService,
    private reportProvider: ReportProvider,
    private modalService: BsModalService,
    private logService : LogService
  ) { }

  ngOnInit(): void {
    this.reportSub = this.reportService.report$.subscribe(currentReport => {
      this.currentReport = currentReport;
      this.loadFiles();
    });
  }

  ngOnDestroy(): void {
    if (this.reportSub) this.reportSub.unsubscribe();
  }

  loadFiles(): void {
    if (this.currentReport) {
      this.isLoading = true;
      this.reportProvider.getReportFiles(this.currentReport.ID)
        .subscribe(
          data => {
            if (data.success) {
              this.allFiles = ReportFile.parseArray(data.result);
              if(this.allFiles?.length > 0){

                let root = this.allFiles.find(d => d.TYPE == ReportFileType.FOLDER && (d.PARENT_ID == null || d.PARENT_ID == undefined));
                this.rootFolder = root;
                this.folderSelected = JSON.parse(JSON.stringify(root));
                this.getChildFile(root);
              }

              this.fileAction = FileAction.ROOT_SELECTED;
            }
            this.isLoading = false;
          }, () => {
            this.isLoading = false;
          });
    }
  }

  pickFile(): void {
    this.attachFileRef.nativeElement.click();
  }

  getChildFile(parent: ReportFile): void {
    let tempArray: ReportFile[] = Object.assign([],this.allFiles);// JSON.parse(JSON.stringify(this.allFiles));
    this.reportFiles = [];
    if(tempArray.length > 0){
      this.reportFiles = tempArray.filter(f => f.PARENT_ID == parent.ID);
    }
  }

  /** Filter list of items in tree */
  filterItemsInTree(): void{
    let tempArray: ReportFile[] = JSON.parse(JSON.stringify(this.reportFiles));
    this.reportFiles = [];
    tempArray.map((item) => {
      if(item.PARENT_ID !== this.rootFolder.ID){
        let addItem = this.findParent(item, tempArray);
        if(addItem){
          if(!this.reportFiles?.find(v => v.ID === addItem.ID))
            this.reportFiles.push(addItem);
          else{
            this.reportFiles.map(value => {
              if(value.ID === addItem.ID)
                value = addItem;
            });
          }
        }
      }else{
        if(item.ID !== this.rootFolder.ID)
          this.reportFiles.push(item);
      }
    });
  }

  /** Find its parent node and push item in array */
  findParent(item: ReportFile, array: ReportFile[]): ReportFile{
    let returnItem: ReportFile = null;
    array.map((parent) => {
      if(parent.ID === item.PARENT_ID){
        returnItem = parent;
        if(returnItem.PARENT_ID){
          if(!returnItem?.childrens?.find(v => v.ID === item.ID)){
            returnItem.childrens = returnItem.childrens ? returnItem.childrens : [];
            returnItem.childrens.push(item);
          }
          returnItem = this.findParent(returnItem, array);
        }else{
          if(!returnItem?.childrens?.find(v => v.ID === item.ID)){
            returnItem.childrens = returnItem.childrens ? returnItem.childrens : [];
            returnItem.childrens.push(item);
          }
          else
            returnItem = null;
        }
      }
    });
    return returnItem;
  }

  /** Display selected files for node */
  displaySelectedNode(event: ReportFile): void{
    this.folderSelected = event;
  }

  /** Get Name of Parent Folder of File */
  getParentName(item: ReportFile, arrayFile: ReportFile[]): string {
    let strName: string[] = [item.NAME];

    if(item.PARENT_ID){
      let found = arrayFile.find(f => f.ID == item.PARENT_ID);

      if(found){
        strName.unshift(found.NAME);

        if(found.PARENT_ID){
          let subParent = arrayFile.find(f => f.ID === found.PARENT_ID);
          strName.unshift(this.getParentName(subParent, arrayFile));
        }
      }
    }
    return strName.join('/');
  }

  /** Download File */

  downloadFile(item:ReportFile): void {
    this.isLoading = true;
    let path = this.getParentName(this.folderSelected, this.allFiles);
    this.reportProvider.downloadFile(this.currentReport.ID, path, item.ID)
      .subscribe(response => {
        const blob = new Blob([response], { type: response.type });
        saveAs(blob, item.NAME);
        this.isLoading = false;
      }, err => {
        this.logService.log(err);
        this.isLoading = false;
      });
  }

  /**Download All Zip */
  downloadZip(): void {
    this.isLoading = true;
    let path = this.getParentName(this.folderSelected, this.allFiles);

    const selected = this.reportFiles.filter(s => s.SELECTED).map(s => s.ID);

    this.reportProvider.downloadZip(this.currentReport.ID, path, selected)
      .subscribe(response => {
        const blob = new Blob([response], { type: 'application/zip' });
        saveAs(blob, "download.zip");
        this.isLoading = false;
      }, err => {
        this.logService.log(err);
        this.isLoading = false;
      });
  }

  /**Delete All */
  deleteAll(): void {
    this.modalRef = this.modalService.show(ConfirmationDialogComponent, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.modalRef.content.title = 'Delete File';
    this.modalRef.content.text = 'Are you sure you want to delete?';
    this.modalRef.content.actionButton = 'Confirm';
    this.modalRef.content.subject = ackSubject;

    ackSubject.subscribe(value => {
      if(value){
        this.isLoading = true;
        let path = this.getParentName(this.folderSelected, this.allFiles);
        const selected = this.reportFiles.filter(s => s.SELECTED).map(s => s.ID);
        this.reportProvider.deleteAll(this.currentReport.ID, path, selected)
          .subscribe(data => {
            if(data.success){
              
              for(let id of selected){
                let found = this.allFiles.find(f => f.ID == id);
                this.allFiles.splice(this.allFiles.indexOf(found), 1);

                let item = this.reportFiles.find(f => f.ID == id);
                this.reportFiles.splice(this.reportFiles.indexOf(item), 1);

                this.isCheck = false;
              }
            }
            this.isLoading = false;
          }, err => {
            this.logService.log(err);
            this.isLoading = false;
          });
      }
    });
  
  }

  /** Create New Folder */
  createFolder(): void {
    this.modalRef = this.modalService.show(CreateFolderModal, Helpers.getModalConfig());
    const ackSubject = new Subject<ReportFile>();
    this.modalRef.content.subject = ackSubject;
    this.modalRef.content.report = this.currentReport;
    this.modalRef.content.selected = this.folderSelected != null ? this.folderSelected : null;
    this.modalRef.content.actionType = FileActionType.CREATE_FOLDER;
    this.modalRef.content.path = this.folderSelected != null ? this.getParentName(this.folderSelected, this.allFiles) : null;

    ackSubject.subscribe(value => {
      if (value) {
        this.allFiles.push(value);

        if(this.folderSelected == null){
          this.rootFolder = value;
          this.getChildFile(this.rootFolder);
        }
        else {
          this.reportFiles.push(value);
        }
      }
    });
  }

  /** Upload New file  */
  upload(): void {
    this.modalRef = this.modalService.show(UploadFileModal, Helpers.getModalConfig());
    const ackSubject = new Subject<ReportFile[]>();
    this.modalRef.content.subject = ackSubject;
    this.modalRef.content.report = this.currentReport;
    this.modalRef.content.selected = this.folderSelected;
    this.modalRef.content.path = this.getParentName(this.folderSelected, this.allFiles);

    ackSubject.subscribe(value => {
      if (value) {
        for(let r of value){
          this.allFiles.push(r);
        }
        this.reportFiles = JSON.parse(JSON.stringify(this.allFiles));
        this.filterItemsInTree();
      }
    });
  }

  /** Rename Folder or File */

  rename(item:ReportFile): void {
    this.modalRef = this.modalService.show(CreateFolderModal, Helpers.getModalConfig());
    const ackSubject = new Subject<ReportFile>();
    this.modalRef.content.subject = ackSubject;
    this.modalRef.content.report = this.currentReport;
    this.modalRef.content.selected = item;
    this.modalRef.content.actionType = FileActionType.RENAME;
    this.modalRef.content.folderName = item.NAME;
    this.modalRef.content.path = this.getParentName(this.folderSelected, this.allFiles);

    ackSubject.subscribe(value => {
      if (value) {
        item.NAME = value.NAME;

        let found = this.allFiles.find(f => f.ID == item.ID);
        found.NAME = item.NAME;
      }
    });
  }

  /** Rename Folder or File */

  changeType(item:ReportFile): void {
    this.modalRef = this.modalService.show(CreateFolderModal, Helpers.getModalConfig());
    const ackSubject = new Subject<ReportFile>();
    this.modalRef.content.subject = ackSubject;
    this.modalRef.content.report = this.currentReport;
    this.modalRef.content.selected = item;
    this.modalRef.content.folderName = item.NAME;
    this.modalRef.content.actionType = FileActionType.CHANGE_TYPE;
    this.modalRef.content.path = this.getParentName(this.folderSelected, this.allFiles);

    ackSubject.subscribe(value => {
      if (value) {
        item.DOCUMENT_TYPE = value.DOCUMENT_TYPE;
        let found = this.allFiles.find(f => f.ID == item.ID);
        found.DOCUMENT_TYPE = item.DOCUMENT_TYPE;
      }
    });
  }

  /** Delete Folder of File */
  
  delete(item: ReportFile): void {
    this.modalRef = this.modalService.show(ConfirmationDialogComponent, Helpers.getModalConfig());
    const ackSubject = new Subject<Boolean>();
    this.modalRef.content.title = 'Delete File';
    this.modalRef.content.text = 'Are you sure you want to delete?';
    this.modalRef.content.actionButton = 'Confirm';
    this.modalRef.content.subject = ackSubject;
    ackSubject.subscribe(value => {
      if(value){
        let path = this.getParentName(this.folderSelected, this.allFiles);
        this.reportProvider.deleteFile(this.currentReport.ID, path, item.ID)
          .subscribe(data => {
            if(data.success){
              let found = this.allFiles.find(f => f.ID == item.ID);
              this.allFiles.splice(this.allFiles.indexOf(found), 1);
              this.reportFiles.splice(this.reportFiles.indexOf(item), 1);
            }
          }, err => {
            this.logService.error(err);
          });
        }
    });
  }

  getDocumentName(type: DocumentType): string {
    let found = Helpers.getDocuments().find(d => d.VALUE == type);

    if(found)
      return found.getName();

    return '';
  }

  onNavLinkClick(navField: ReportFile, index: number): void {
    this.reportFiles.splice(index + 1);
    this.getChildFile(navField);
  }

  openFolder(file: ReportFile){
    if(file.TYPE == ReportFileType.FOLDER){
       this.reportFiles = this.allFiles.filter(f => f.PARENT_ID == file.ID);
       this.folderSelected = file;
       this.childNav.push(file);
       this.fileAction = FileAction.FOLDER_SELECTED;
    }
  }

  goRoot(): void {
    this.childNav = [];
    this.loadFiles();
  }

  fileChangeEvent(event: any): void {
    const formData = new FormData();
     formData.append("path", this.folderSelected.NAME);

    if (event.target.files.length > 0) {
      const files = event.target.files;
      for (const f of files) {
        formData.append('files', f);
      }
    }

    this.reportProvider.addReportFiles(this.currentReport.ID, formData, this.folderSelected.ID)
      .subscribe(data => {
        if (data.success) {
          let newFiles = ReportFile.parseArray(data.result);
          for(let r of newFiles){
            this.reportFiles.push(r);
            this.allFiles.push(r);
          }
        }
      }, err => {
        this.logService.error(err);
      });
  }

  fileDropped(files: NgxFileDropEntry[]): void {
    //this.isLoading = true;
    //const formData = new FormData();
    //formData.append("path", this.getParentName(this.folderSelected, this.allFiles));

    files.forEach((droppedFile,index) => {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        const reader = new FileReader();

        fileEntry.file((file: File) => {
           reader.readAsDataURL(file);

           reader.onload = () => {
            let newUpload: ReportFile = new ReportFile();
            newUpload.FILE_DATA = reader.result;
            newUpload.NAME = file.name;
            newUpload.SIZE = file.size;
            newUpload.TYPE = ReportFileType.FILE;
            this.files.push(newUpload);

            if(index === files.length-1){
              this.startUpload();
            }
          };

          //formData.append('files', file);
        });
      }
    });
  }

  onCheckedFile(value: boolean, item: ReportFile): void{
    if(value){
      this.checkedSelected = item;
      this.fileAction = FileAction.CHECK_SELECTED;
    }else {
      if(this.fileSelected() == 0){
        this.checkedSelected = null;
        this.fileAction = this.rootFolder.ID == this.folderSelected?.ID ? FileAction.ROOT_SELECTED : FileAction.FOLDER_SELECTED;
      }
    }
  }

  checkAll(value: boolean): void {
    if(value){
      this.fileAction = FileAction.CHECK_SELECTED;
    }
    else {
      this.checkedSelected = null;
      this.fileAction = this.rootFolder.ID == this.folderSelected?.ID ? FileAction.ROOT_SELECTED : FileAction.FOLDER_SELECTED;
    }

    if(this.reportFiles?.length > 0){
      for(let r of this.reportFiles){
        r.SELECTED = value;
      }
    }
  }

  checkSelectAll(): boolean {
    let reportDiff = this.reportFiles.find((file) => {
      if(!file.SELECTED){
        return file;
      }
    });

    return !reportDiff ? true : false;
  }

  fileSelected(): number {
    if(this.reportFiles.length > 0){
      return this.reportFiles.filter(f => f.SELECTED).length;
    }

    return 0;
  }

  getFileExtension(filename: string): string {
    return filename.split('.').pop();
  }

  startUpload(): void {
    this.isUpload = true;
    let path = this.getParentName(this.folderSelected, this.allFiles);
    this.reportProvider.uploadFiles(this.currentReport.ID, this.files, this.folderSelected.ID, path)
      .subscribe(resp => {
        if (resp.type === HttpEventType.Response) {
          this.isUpload = false;
          let newFiles = ReportFile.parseArray(resp.body.result);

          for(let r of newFiles){
            this.reportFiles.push(r);
            this.allFiles.push(r);
          }

          this.files = [];
        }
        if (resp.type === HttpEventType.UploadProgress) {
            const percentDone = Math.round(100 * resp.loaded / resp.total);
            this.uploadProgress = percentDone;
        }
      }, err => {
        this.logService.error(err);
        this.isUpload = false;
      });
  }


  onPreview(item : ReportFile): void {
    if(item.TYPE == ReportFileType.FILE){

    this.alert.hide();
    const config = Helpers.getModalConfig();
    config.class = 'modal-lg';
    let path = this.getParentName(this.folderSelected, this.allFiles);

    if(this.getFileExtension(item.NAME) == ExtenstiionType.pdf){
      this.isLoading = true;
      this.reportProvider.previewFile(this.currentReport.ID, path, item.ID)
      .subscribe(response => {
        this.isLoading = false;
        const src = new Uint8Array(response);

        this.modalRef = this.modalService.show(PreviewFileComponent, config);
        const ackSubject = new Subject<Boolean>();
        this.modalRef.content.subject = ackSubject;
        this.modalRef.content.name = item.NAME;
        this.modalRef.content.source = src;

        ackSubject.subscribe(result => {
          if (result) { this.logService.log(result); }
        });
      }, err => {
        this.logService.log(err);
        this.isLoading = false;
      });
    }
    else {
      this.alert.showError("Preview supports only .pdf file at this moment. Use download button instead.");
      setTimeout(() => {
        this.alert.hide();
      }, 3000);
    }
  }
  }

  getFileCount(): string {
    let count = this.allFiles.filter(f => f.TYPE == ReportFileType.FILE).length;

    let str = "file";

    if(count > 1)
      str = "files";

    return `${count} ${str}`;
  }
}

export enum FileAction {
  CHECK_SELECTED = 'CHECK_SELECTED',
  FOLDER_SELECTED = 'FOLDER_SELECTED',
  ROOT_SELECTED = 'ROOT_SELECTED'
}

export enum ExtenstiionType {
  xlsx = 'xlsx',
  xls = 'xls',
  pdf = 'pdf',
  docx = 'docx',
  doc = 'doc',
  zip = 'zip',
  rar = 'rar',
  txt = 'txt'
}
